import type { AxiosRequestConfig } from 'axios';

import { useConfiguration } from '../contexts';

export const useCustomHeaders = (): AxiosRequestConfig['headers'] => {
  const { tenant, registrationId } = useConfiguration();

  const headers: AxiosRequestConfig['headers'] = {
    'x-tenant-context': tenant,
    'x-registration-id': registrationId,
  };

  return headers;
};
